import {Image} from "@chakra-ui/react";
import Heading from "./Heading";
import Button from "./Button";

import { Tokens } from "../mirrorful/theme";
import Text from "./Text";
import { useEffect, useState } from "react";


import "./BackGround.css"

//https://pinnacle.works/wp-content/uploads/2022/06/dummy-image.jpg
export default function Home({id}){
 
  const textState = ["istyping", "isdeleting"];
const [typing, setTyping] = useState(textState[0]);

function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

  const first_text = "Hi, I'm Abhishree";


  const [text1, setText1] = useState("");



  useEffect(() => {
    const timeout = setTimeout(() => {
      if (typing === "istyping" && text1 !== first_text) {
        setText1(first_text.slice(0, text1.length + 1));
      }
      else if (text1 === first_text && typing === "istyping"){
        sleep(2000).then(()=>{
        setTyping(textState[1])
        })
      }
      else if ( (text1 === first_text && typing==="isdeleting") || typing === "isdeleting" ) {
        setText1(first_text.slice(0, text1.length - 1));
        if(text1.length<=2){
            setTyping(textState[0])
        }
      }
    }, 100);
  return () => clearTimeout(timeout);
}, [text1, typing]);


 
    return (
      <>
     

        <div

        id={id}
        style={{
          // remove position til left for removing dot effect
          position: "relative",
          zIndex:1,
          top: 50,
  left: 0,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '64px 25%',
        }}
      >
       
         
         <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          marginTop: '32px',
        }}
      >
         <Image
         className="home-img"
          src="https://res.cloudinary.com/dsixdct6o/image/upload/v1695675073/Screenshot_2023-09-26_at_02.19.00_copy_ywy3yd.png"
          width={150}
          height={150}
          alt="headshot"
          style={{
            objectFit: 'cover',
            borderRadius: '50%',
            width: '150px',
            height: '150px',
            boxShadow: `0 0 50px 10px ${Tokens.purple.shades['400']}`,
          }}
        />
        <Heading
        id="user-detail-name"
        text={text1}
        style={{ marginTop: '64px' }}
        size="lg"
        />
        
         {/* <Flex text="white" id="user-detail-name" marginTop= '64px' size="lg" bgGradient={`linear(to-br, white, white, ${Tokens.background.base})`} bgClip={"text"}>
        <Typewriter
        style={{text:"white",id:"user-detail-name",marginTop: '64px',size:"lg",bgGradient:`linear(to-br, white, white, ${Tokens.background.base})`,bgClip:"text",}}
 
 onInit={(typewriter) => {
     typewriter
         .typeString("Hi, I'm Abhishree")
         .pauseFor(1000)
         .start();
        //  .typeString("Welcomes You")
         
 }}
/>
</Flex> */}
         <Text id={"user-detail-intro"} style={{ textAlign: 'center', marginTop: '12px' }} size="md">
          {`I'm a passionate front-end developer skilled in the MERN stack,`}
          <br /> {`focused on creating immersive user experiences`}
        </Text>
       <a target="_blank" rel="noopener noreferrer" id="contact-email" href="mailto:bhishree19@gmail.com"> <Button label="Email Me" style={{ marginTop: '32px' }} /></a>
      </div>
      {/* <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '180px',
        }}
      >
        <StageLight/>
        <motion.div
          initial={{
            y: 40,
            opacity: 0.5,
          }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{
            amount: 1,
            margin: '-5%',
          }}
          transition={{
            duration: 0.5,
          }}
          style={{
            marginTop: -20,
          }}
        >
          <Heading
            text={'My Projects'}
            size="md"
            style={{ marginTop: '64px', marginBottom: '32px', color: 'white' }}
          />
        </motion.div>
       
        </div> */}
     
        </div>
        </>
    )
}